import { render } from "./OrgEditDialog.vue?vue&type=template&id=39a9e94c&scoped=true"
import script from "./OrgEditDialog.vue?vue&type=script&lang=js"
export * from "./OrgEditDialog.vue?vue&type=script&lang=js"

import "./OrgEditDialog.vue?vue&type=style&index=0&id=39a9e94c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a9e94c"]])

export default __exports__